// src/components/MessageCard.js
import { convertUTCToLocal, getLogLevel } from "../../helpers/utils";

import React from "react";

function MessageCard({ message }) {
  const { content, content_type, metadata } = message;

  const logLevel = getLogLevel(content);

  const renderContent = () => {
    switch (content_type) {
      case "media":
        const mediaType = metadata?.media_type || "image";
        if (mediaType.startsWith("image")) {
          return (
            <img
              src={content}
              alt={metadata?.filename || "Media"}
              className="w-full h-auto rounded mb-2"
            />
          );
        } else if (mediaType.startsWith("video")) {
          return (
            <video controls className="w-full h-auto rounded mb-2">
              <source src={content} type={mediaType} />
              Your browser does not support the video tag.
            </video>
          );
        } else {
          return <p>Unsupported media type</p>;
        }
      case "url":
        return (
          <a
            href={content}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline mb-2"
          >
            {content}
          </a>
        );
      default:
        return <p>{content}</p>;
    }
  };

  let fullTime = convertUTCToLocal(message.timestamp);
  let date = fullTime.split(", ")[0];
  let time = fullTime.split(", ")[1];

  return (
    <div
      className={`bg-gray-100 shadow-md rounded-lg px-3 py-1 mb-2 flex flex-row gap-5 justify-start log-${logLevel}`}
    >
      <div className="flex flex-col">
        <div className="text-gray-400 text-xs">{date}</div>
        <div className="text-gray-700 text-xs">{time}</div>
      </div>
      <div className="my-auto">{renderContent()}</div>
    </div>
  );
}

export default MessageCard;
